module.exports = __webpack_public_path__ + "media/images/badge/partita-perfetta_secondary-9df8a24efd1c008d11aa27cfc64be187.png";